import React from 'react';
import { Link } from 'react-router-dom';
import { CardElement, ElementsConsumer } from '@stripe/react-stripe-js';
import PropTypes from 'prop-types';
import poweredByStripe from '../../images/powered-by-stripe.png';

export default class InjectedCheckoutForm extends React.Component {
  static propTypes = {
    onSubscribe: PropTypes.func
  }

  render () {
    return (
      <ElementsConsumer>
        {({ elements, stripe }) => (
          <CreditCard elements={ elements } stripe={ stripe } onSubscribe={ this.props.onSubscribe } />
        )}
      </ElementsConsumer>
    );
  }
}

class CreditCard extends React.Component {
  static propTypes = {
    stripe: PropTypes.object,
    elements: PropTypes.object,
    onSubscribe: PropTypes.func
  }

  state = {
    isProcessing: false
  }

  static cardStyleOptions = {
    style: {
      base: {
        fontSize: '18px',
        fontFamily: 'Roboto Slab',
        '::placeholder': {
          color: '#aab7c4',
        }
      },
      invalid: {
        color: '#9e2146',
      },
    },
    hidePostalCode: true,
    autocomplete: {
      cardNumber: 'cc-number',
      cardExpiry: 'cc-exp',
      cardCvc: 'cc-csc'
    }
  };

  onSubscribe = async (event) => {
    event.preventDefault();
    this.setState({ isProcessing: true });

    try {
      const cardElement = this.props.elements.getElement(CardElement);
      const { error, paymentMethod } = await this.props.stripe.createPaymentMethod({
        type: 'card',
        card: cardElement
      });

      if (!error) {
        await this.props.onSubscribe(paymentMethod.id);
      }
    } finally {
      this.setState({ isProcessing: false });
    }
  };

  render() {
    return (
      <form onSubmit={ this.onSubscribe.bind(this) } className='credit-card'>
        <CardElement onReady={ (el) => el.focus() } options={ { ...CreditCard.cardStyleOptions } }/>
        <a href='https://stripe.com/' className="powered-by-stripe" target='_blank' rel='noopener noreferrer'>
          <img src={ poweredByStripe }  alt="Powered by Stripe" />
        </a>
        <span className='dot-spacer'></span>
        <span className='validation-as-seen-in'>as seen in</span>
        <a href='https://www.makeuseof.com/best-websites-apps-that-improve-your-prose/' className="muo-mini validation-logo" target='_blank' rel='noopener noreferrer'>
          <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/muo-small.png' alt='Make Use Of'></img>
        </a>
        <a href='https://techcrunch.com/2021/04/15/yak-tack-is-a-super-simple-app-to-boost-vocabulary/' className="tc-mini validation-logo" target='_blank' rel='noopener noreferrer'>
          <img src='https://yaktack-prod-images.s3-us-west-2.amazonaws.com/tc-small.png' alt="TechCrunch" />
        </a>
        <div className='action'>
          <button className='btn btn-dark' disabled={this.state.isProcessing}>
            {this.state.isProcessing ? 'Processing...' : 'Go Unlimited'}
          </button>
          {this.state.isProcessing ? (
            <button className='btn' disabled>Stay Free</button>
          ) : (
            <Link to='/' className='btn'>Stay Free</Link>
          )}
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/subscription/credit_card.jsx